const data = {
  subscribeThanks: 'You email has been added to the mailing list successfully!',
  contactThanks:
    'Your request has been sent, a member of the support team will get in contact with you through the email you provided as soon as possible.',
  signUpRequest:
    'Your Sign Up request has been submited, you are now a member of the Healing .',
  ticketThanks:
    'You purchase has been submitted, you should receive an email with the receipt soon.',
  therapistThanks:
    'Thank you for your interest in working with Healing, we have recieved your application.You will receive an email guiding you for the next steps soon after your information is reviewed.',
  editThanks:
    'Changes submitted, you will be able to see the changes in your profile.',
  cardThanks:
    'Your new payment method is under review, you will receive an email soon when your card is confirmed.Otherwise you will get a notification telling you what went wrong and how to add a new card.',
};
export { data };
